import React, { useEffect, useState } from 'react'
import gsap from 'gsap'
import SplitType from 'split-type';
import { ToastContainer, toast } from 'react-toastify';
import CursorPointer from './Cursor';
import { Link } from 'react-scroll';
import SpringModal from './SpringModal';
import {motion} from 'framer-motion'

const userDataSets = [
    {
        name: 'Nikita Jain',
        email: '1 day',
        imageUrl: 'https://randomuser.me/api/portraits/women/79.jpg',
    },
    {
        name: 'Srajan Shrivastava',
        email: '44 minutes',
        imageUrl: 'https://randomuser.me/api/portraits/men/42.jpg',
    },
    {
        name: 'Shrashti Bhumarkar',
        email: '1 hour',
        imageUrl: 'https://randomuser.me/api/portraits/men/42.jpg',
    },
    {
        name: 'Aryan Parashar',
        email: '2 Days',
        imageUrl: 'https://randomuser.me/api/portraits/men/42.jpg',
    },
    {
        name: 'Vaisnavi Gupta',
        email: '7 Hour',
        imageUrl: 'https://randomuser.me/api/portraits/men/42.jpg',
    },
    {
        name: 'Mishty Verma',
        email: '6 hour',
        imageUrl: 'https://randomuser.me/api/portraits/men/42.jpg',
    },
    // Add more data sets as needed
];

export default () => {
    const [isOpen, setIsOpen] = useState(false);
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);
    const [size, setSize] = useState(32);
    const [userDataIndex, setUserDataIndex] = useState(0);
    const [userData, setUserData] = useState(userDataSets[userDataIndex]);

    useEffect(() => {
        const handleMouse = (e) => {

            setX(e.clientX)
            setY(e.clientY)
        }
        document.addEventListener("mousemove", handleMouse)
        return () => {
            document.addEventListener("mousemove", handleMouse)
        }
    }, [x, y])
    useEffect(() => {
        // Function to handle transitioning to the next data set
        const transitionToNextDataSet = () => {
            setUserDataIndex((prevIndex) => (prevIndex + 1) % userDataSets.length);
        };

        // Set up a timer to transition every 2 seconds
        const intervalId = setInterval(transitionToNextDataSet, 5000);

        // Clear the interval when the component unmounts
        return () => clearInterval(intervalId);
    }, []); // Empty dependency array to run only once when the component mounts

    useEffect(() => {
        // Update userData when userDataIndex changes
        setUserData(userDataSets[userDataIndex]);
    }, [userDataIndex]);

    const Avatar = () => (

        <>
            <div className=' w-full px-8 flex justify-center items-center text-center'>
                <p className='  text-lg text-text-orange font-semibold'>
        🎉<span className=' text-text-logo'>{userData.name}</span> joined the course just before {userData.email}
                </p>
            </div>

        </>
    )


    const Submit = () => {
        var name = document.getElementById("name").value;
        var phone = document.getElementById("phone").value;
        var email = document.getElementById("email").value;
        if (document.cookie.includes("formSubmitted=true")) {
            toast.warn("we already got your response!");
            return;
        }

        if (name && phone && email) {
            var formData = {
                name: name,
                phone: phone,
                email: email,

            };

            // Make a POST request to Google Apps Script
            fetch('https://script.google.com/macros/s/AKfycbwubEGr0m_HWysAp_5xCmLS1wIkhOD1A_llkIH6m5FNkJz3Fe3u69Cg1Ohs_AtzAScWGA/exec', {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData)
            })
            .then(response => {
                const expirationDate = new Date();
                expirationDate.setMonth(expirationDate.getMonth() + 1);
    
                document.cookie = `formSubmitted=true; expires=${expirationDate.toUTCString()}`;
                toast.success("Your Response submitted successfully🥳");
                
                // Clear form fields
                document.getElementById("name").value = "";
                document.getElementById("phone").value = "";
                document.getElementById("email").value = "";
            })
          
                .catch(error => {
                    toast.error('Error submitting form 😏 ' + error);

                });
        } else {
            toast.warn("Please fill in all the fields😏");
        }

    }
    return (
        <section id='home' className='py-16 relative  flex justify-center items-center flex-col'>


            <style>
                {`
             .p{
                font-size: 2rem;
                line-height: 0;
                margin: 0;
                &:nth-of-type(4){
                  color: yellow;
              
                }
                .cursor:hover{
                    cursor: none;
                  }
              }`}
            </style>
            <SpringModal isOpen={isOpen} setIsOpen={setIsOpen} />
            <div className=" w-full  flex justify-start items-start lg:pl-32 lg:pr-20 px-4 lg:py-20  md:w-11/12 lg:w-full md:px-8">
                <div className="items-start w-full h-full gap-x-12 sm:px-4 md:px-0 lg:flex">
                    <div className=" px-4 cursor   mt-6 sm:px-0 md:mt-0 lg:w-1/2 w-full">
                        <div className=' '>
                            <p className='lg:text-6xl text-4xl text-black  font-extrabold' style={{ fontFamily: "Mulish" }}> <span className=' text-text-orange   scale-150'>Blockchain</span> Mastery Unleashed! 🚀</p>


                        </div>

                        <p className=" lg:text-2xl mt-5 text-md font-medium">
                            Revolutionize your skills with our dynamic blockchain course. From basics to breakthroughs, become the architect of the decentralized future. Join us - where innovation meets education! 🌐✨
                        </p>
                        <div className=' my-16 flex lg:flex-row flex-col gap-x-2 '>
                        <motion.button whileHover={{scale:1.05}} whileTap={{scale:0.85}} transition={{duration:0.2}} onClick={()=>setIsOpen(!isOpen)} className='text-white rounded px-6 py-2  flex justify-center items-center  font-semibold  lg:w-4/12 w-full  bg-bg-orange'  >
                            Download Broucher
                        </motion.button>
                        <Link className=' justify-center items-center flex  rounded px-6 py-2 cursor-pointer text-lg font-bold    lg:w-4/12 w-full  text-text-orange' to='overview' smooth={true} >
                            Go To Course
                        </Link>
                        </div>
                    </div>
                    <div className=" flex lg:w-1/2 w-full h-full  lg:px-24 lg:block">

                        <div className=" form px-4 p-4 shadow-md h-full w-full  bg-white  sm:px-8 sm:rounded-xl">

                            <h1 className='text-center  text-text-logo my-5 font-bold text-3xl my-2'>Apply Now</h1>
                            <form
                                onSubmit={(e) => e.preventDefault()}
                                className="space-y-5"
                            >
                                <div>
                                    <label className="font-medium">
                                        Full name
                                    </label>
                                    <input
                                        id='name'
                                        type="text"
                                        required
                                        className="w-full mt-2 px-3 py-2  text-text-black-dark bg-transparent outline-none border focus:border-gray-800 shadow-sm rounded-lg"
                                    />
                                </div>
                                <div>
                                    <label className="font-medium">
                                        Email
                                    </label>
                                    <input
                                        id='email'
                                        type="email"
                                        required
                                        className="w-full mt-2 px-3 py-2 text-text-black-dark bg-transparent outline-none border focus:border-gray-800 shadow-sm rounded-lg"
                                    />
                                </div>
                                <div>
                                    <label className="font-medium">
                                        Phone number
                                    </label>
                                    <div className="relative mt-2">
                                        <div className="absolute inset-y-0 left-3 my-auto h-6 flex items-center border-r pr-2">
                                            <select className="text-sm bg-transparent outline-none rounded-lg h-full">
                                                <option>IN</option>

                                            </select>
                                        </div>
                                        <input
                                            id='phone'
                                            type="number"
                                            placeholder=""
                                            required
                                            className="w-full pl-[4.5rem] pr-3 py-2 appearance-none bg-transparent outline-none border focus:border-gray-800 shadow-sm rounded-lg"
                                        />
                                    </div>
                                </div>

                                <motion.button whileHover={{scale:1.01}} whileTap={{scale:0.85}} transition={{duration:0.2}} onClick={Submit}
                                    className="w-full px-4 py-2 text-white font-semibold   bg-bg-logo   rounded-lg duration-150"
                                >
                                    Submit
                                </motion.button>

                                <Avatar />
                            </form>
                        </div>


                    </div>

                </div>
            </div>
            {/* <CursorPointer x={x} y={y}/> */}
            <ToastContainer />
        </section>
    )
}